import { connect } from 'react-redux';
import CacaAoTesouroGlobalCheck from '../components/CacaAoTesouroGlobalCheckComponent';
import {
    validateIfHasActiveTesouro, setPageViewAndCheckWin,
    changeLogStatusAndSendMail, checkSomeReservedPrize,
    setShowModal, setShareSituation, setShowSign,
} from '../actions/CacaAoTesouroGlobalCheckAction';
import { checkInfoActiveHunt } from '../../cacaAoTesouro/actions/CacaAoTesouroAction';

const mapStateToProps = (state) => ({
    hasActiveHunt: state.cacaAoTesouroGlobalCheck.hasActiveHunt,
    userWonPremio: state.cacaAoTesouroGlobalCheck.userWonPremio,
    token: state.profile.jwt,
    registrationComplete: !!state.profile.user.registrationComplete,
    checkedReservedPrize: state.cacaAoTesouroGlobalCheck.checkedReservedPrize,
    showModal: state.cacaAoTesouroGlobalCheck.showModal,
    huntAllInfos: state.cacaAoTesouro.huntAllInfos,
    showSign: state.cacaAoTesouroGlobalCheck.showSign,
});

const mapDispatchToProps = (dispatch) => ({
    validateIfHasActiveTesouro: () => dispatch(validateIfHasActiveTesouro()),
    setPageViewAndCheckWin: () => dispatch(setPageViewAndCheckWin()),
    changeLogStatusAndSendMail: () => dispatch(changeLogStatusAndSendMail()),
    checkSomeReservedPrize: () => dispatch(checkSomeReservedPrize()),
    handleModal: (modal = false) => dispatch(setShowModal(modal)),
    setShareSituation: (shareSituation) => dispatch(setShareSituation(shareSituation)),
    checkInfoActiveHunt: () => dispatch(checkInfoActiveHunt()),
    setShowSign: (showSign) => dispatch(setShowSign(showSign)),
});

const CacaAoTesouroGlobalCheckContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(CacaAoTesouroGlobalCheck);

export default CacaAoTesouroGlobalCheckContainer;
